import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 18.75a6.96 6.96 0 0 1-6.07-3.5c-1.258-2.16-1.258-4.812 0-7A7.02 7.02 0 0 1 12 4.75c2.488 0 4.785 1.34 6.043 3.5 1.258 2.188 1.258 4.84 0 7A6.95 6.95 0 0 1 12 18.75m.875-10.062a.47.47 0 0 0-.437-.438.45.45 0 0 0-.438.438v6.124c0 .247.191.438.438.438a.45.45 0 0 0 .437-.437zm-3.5.874a.47.47 0 0 0-.437-.437.45.45 0 0 0-.438.438v4.374c0 .247.191.438.438.438a.45.45 0 0 0 .437-.437zm5.25.657a.47.47 0 0 0-.437-.438.45.45 0 0 0-.438.438v3.062c0 .246.191.438.438.438a.45.45 0 0 0 .437-.438zm-3.5.437a.47.47 0 0 0-.437-.437.45.45 0 0 0-.438.437v2.188c0 .246.191.437.438.437a.45.45 0 0 0 .437-.437zm5.25.656a.47.47 0 0 0-.437-.437.45.45 0 0 0-.438.438v.874c0 .247.191.438.438.438a.45.45 0 0 0 .437-.437z"
    }, null, -1)
  ]))]))
}
export default { render: render }